import { FC, HTMLAttributes } from 'react';

interface IServicesInfoItemProps extends HTMLAttributes<HTMLParagraphElement> {
  text: string;
  textSubMenu?: string[];
}

const ServicesInfoItem: FC<IServicesInfoItemProps> = ({
  text,
  textSubMenu,
}) => {
  return (
    <>
      <p className="custom-p w-[90%] mx-auto ">{text}</p>
      {textSubMenu && (
        <ul className=" marker:text-black list-decimal">
          {textSubMenu.map((i, id) => (
            <li key={id} className="w-[85%] mx-auto">
              <p className={`custom-p mb-4 pl-4`}>{i}</p>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default ServicesInfoItem;
